export default __webpack_public_path__ + "static/media/uiux-design-starter-with-adobe-xd.4fe82ac4.md";